import { LOGIN_ADMIN, LOGIN_RESELLER, LOGOUT } from '../actions/types';

const initialState = {
    invalidLogin: false,
    twoFASetupRequired: false,
    qr: null,
    secret: null,
    user: null,
    loginTrigger: 0,
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_ADMIN:
            return { ...action.payload, loginTrigger: state.loginTrigger + 1 }
        case LOGIN_RESELLER:
            return { ...action.payload, loginTrigger: state.loginTrigger + 1 }
        case LOGOUT:
            console.log('LOGOUT');
            return initialState;
        default:
            return state;
    }
}